{
	"language": {
		"aria": "Vaihda kieltä"
	},
	"placeholder": {
		"title": "Ehdokaskeskuksesi on valmistumassa",
		"body": "Täällä ei ole vielä mitään. Lähetämme sinulle linkin sähköpostitse, kun keskus on valmis."
	},
	"not_found": {
		"title": "Sivua ei löytynyt",
		"body": "Tarkista käyttämäsi linkki tai käytä sähköpostissasi olevaa linkkiä."
	},
	"error_boundary": {
		"reload": "Lataa sivu uudelleen"
	},
	"login": {
		"loading": "Ladataan…",
		"title": "Kirjaudu ehdokaskeskukseesi",
		"intro": "Syötä sähköpostiosoitteesi nähdäksesi hakemuksesi.",
		"email_label": "Sähköpostiosoite",
		"email_placeholder": "sina@esimerkki.fi",
		"submit": "Kirjaudu",
		"sending": "Lähetetään…",
		"sent": {
			"title": "Tarkista sähköpostisi",
			"body": "Jos {{email}} vastaa jotakin hakemusta, kirjautumislinkki on matkalla.",
			"retry": "Etkö saanut sitä? Tarkista osoite ja yritä uudelleen"
		},
		"resent": {
			"title": "Lähetimme sinulle uuden kirjautumislinkin",
			"body": "Avaamasi linkki on vanhentunut. Jos sähköpostiosoitteesi vastaa jotakin hakemusta, uusi kirjautumislinkki on matkalla. Se avaa saman sivun.",
			"request_manually": "Etkö saanut sitä? Pyydä uusi linkki"
		},
		"request_error": {
			"throttled": "Liian monta yritystä. Odota hetki ja yritä uudelleen.",
			"invalid_email": "Syötä kelvollinen sähköpostiosoite.",
			"generic": "Jokin meni pieleen. Yritä uudelleen."
		},
		"unknown_organisation": {
			"title": "Sivua ei löytynyt",
			"body": "Tarkista käyttämäsi linkki tai käytä sähköpostissasi olevaa linkkiä."
		},
		"error": {
			"title": "Jokin meni pieleen",
			"body": "Sivun lataaminen ei onnistunut. Yritä hetken kuluttua uudelleen."
		}
	},
	"organisations": {
		"title": "Hakemuksesi",
		"intro": "Valitse yritys nähdäksesi sille lähettämäsi hakemukset.",
		"count_one": "{{count}} hakemus",
		"count_other": "{{count}} hakemusta",
		"empty": {
			"title": "Ei vielä hakemuksia",
			"body": "Kun haet johonkin yritykseen, se näkyy täällä."
		},
		"error": "Yritystesi lataaminen ei onnistunut. Yritä hetken kuluttua uudelleen.",
		"log_out": "Kirjaudu ulos",
		"logging_out": "Kirjaudutaan ulos…"
	},
	"submissions": {
		"title": "Aiemmat hakemukset",
		"back_to_organisations": "Kaikki yritykset",
		"cv_uploaded": "CV ladattu",
		"empty": {
			"title": "Ei vielä hakemuksia",
			"body": "Yritykselle {{organisation}} lähettämäsi hakemukset näkyvät täällä."
		},
		"error": "Hakemustesi lataaminen ei onnistunut. Yritä hetken kuluttua uudelleen.",
		"log_out": "Kirjaudu ulos",
		"logging_out": "Kirjaudutaan ulos…"
	},
	"profile": {
		"link": {
			"title": "Profiilisi",
			"cv_added": "CV lisätty",
			"cv_missing": "Ei vielä CV:tä"
		},
		"back": "Takaisin hakemukseen",
		"context": "{{campaign}} · {{organisation}}",
		"contact_consent": "Sinuun saa olla yhteydessä tästä työpaikasta.",
		"cv": {
			"title": "CV",
			"upload": {
				"title": "Lataa CV:si",
				"drop_hint": "tai vedä ja pudota se tähän",
				"constraints": "{{types}}, enintään {{size}} Mt",
				"uploading": "Ladataan {{fileName}}…",
				"done": "CV ladattu",
				"error_type": "Tätä tiedostotyyppiä ei tueta. Sallitut tyypit: {{types}}.",
				"error_size": "Tiedosto on liian suuri. Enimmäiskoko on {{size}} Mt."
			},
			"remove": {
				"label": "Poista {{fileName}}",
				"question": "Poistetaanko {{fileName}}?",
				"consequence": "Työnantaja ei enää näe sitä. Toimintoa ei voi perua.",
				"confirm": "Poista CV",
				"cancel": "Peruuta",
				"removing": "Poistetaan…",
				"error": "CV:n poisto epäonnistui. Yritä uudelleen."
			}
		},
		"work_history": {
			"title": "Työhistoria",
			"description": "Kerro meille olennaisesta työhistoriastasi: missä olet työskennellyt, mitä teit siellä ja kuinka kauan työskentelit siellä. Voit lisätä useamman kuin yhden työpaikan, jos ne ovat olennaisia.",
			"placeholder": "Kuvaile työpaikkaa, jossa olet ollut",
			"input_label": "Työn tiedot",
			"save": "Tallenna",
			"saving": "Tallennetaan…",
			"cancel": "Peruuta",
			"edit": "Muokkaa",
			"remove": "Poista",
			"add_another": "Lisää toinen työpaikka",
			"error_empty": "Kirjoita jotain ennen tallentamista.",
			"error_limit": "Voit lisätä enintään {{max}} työpaikkaa.",
			"unsaved_changes": "Työhistoriassasi on tallentamattomia muutoksia. Haluatko silti poistua ja menettää ne?",
			"hints": {
				"label": "Tämän työn tiedot",
				"included": "mainittu",
				"missing": "ei vielä mainittu"
			}
		},
		"education": {
			"title": "Koulutus",
			"description": "Kerro meille olennaisesta koulutuksestasi: mitä opiskelit, missä ja milloin. Tutkinnot, koulut, kurssit ja sertifikaatit lasketaan kaikki. Voit lisätä useamman kuin yhden.",
			"placeholder": "Kuvaile tutkintoa, koulua tai kurssia",
			"input_label": "Koulutuksen tiedot",
			"save": "Tallenna",
			"saving": "Tallennetaan…",
			"cancel": "Peruuta",
			"edit": "Muokkaa",
			"remove": "Poista",
			"add_another": "Lisää toinen koulutus",
			"error_empty": "Kirjoita jotain ennen tallentamista.",
			"error_limit": "Voit lisätä enintään {{max}} koulutusta.",
			"unsaved_changes": "Koulutustiedoissasi on tallentamattomia muutoksia. Haluatko silti poistua ja menettää ne?"
		},
		"licenses": {
			"title": "Luvat ja sertifikaatit",
			"description": "Kerro meille luvistasi ja sertifikaateistasi, kuten ajokortista, trukkikortista tai hygieniapassista. Kerro, milloin sait sen ja milloin se vanhenee, jos se vanhenee. Voit lisätä useamman kuin yhden.",
			"placeholder": "Kuvaile lupaa tai sertifikaattia",
			"input_label": "Luvan tiedot",
			"save": "Tallenna",
			"saving": "Tallennetaan…",
			"cancel": "Peruuta",
			"edit": "Muokkaa",
			"remove": "Poista",
			"add_another": "Lisää toinen lupa",
			"error_empty": "Kirjoita jotain ennen tallentamista.",
			"error_limit": "Voit lisätä enintään {{max}} lupaa.",
			"unsaved_changes": "Luvissasi on tallentamattomia muutoksia. Haluatko silti poistua ja menettää ne?"
		}
	},
	"submission": {
		"back": "Takaisin hakemuksiini",
		"back_short": "Takaisin",
		"not_found": {
			"title": "Hakemusta ei löytynyt",
			"body": "Tätä hakemusta ei ole olemassa tai se ei ole sinun hakemuksesi."
		},
		"result": {
			"heading": "Vahvistusnäkymä, jonka näit hakemuksen lähettämisen jälkeen"
		},
		"summary": {
			"title": "Yhteenveto vastauksistasi",
			"submitted_on": "Lähetit tämän lomakkeen",
			"submitted_more_than_once": "Täytit tämän lomakkeen useamman kuin kerran. Yhdistämme profiilisi automaattisesti; alla oleva hakemus on uusin."
		}
	}
}
